(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("4QweW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $387506f4e8043722$export$71511d61b312f219; });
function $387506f4e8043722$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6hK4i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $493810cfcf480a5a$export$71511d61b312f219; });
function $493810cfcf480a5a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $493810cfcf480a5a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $493810cfcf480a5a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $493810cfcf480a5a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("6VBea", function(module, exports) {
$parcel$export(module.exports, "b64_decode", function () { return (parcelRequire("hDdJN")).b64_decode; });
$parcel$export(module.exports, "getAllCookies", function () { return (parcelRequire("fnNvV")).getAllCookies; });
$parcel$export(module.exports, "elementReady", function () { return (parcelRequire("7YAJ4")).elementReady; });
$parcel$export(module.exports, "addWindowResizeEvent", function () { return (parcelRequire("2pyvk")).addWindowResizeEvent; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return (parcelRequire("2pyvk")).addWindowScrollEvent; });
$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return (parcelRequire("9uiPq")).getReCAPTCHAResponse; });
$parcel$export(module.exports, "slideDown", function () { return (parcelRequire("cPDzI")).slideDown; });
$parcel$export(module.exports, "slideUp", function () { return (parcelRequire("cPDzI")).slideUp; });
$parcel$export(module.exports, "scrollToElement", function () { return (parcelRequire("9vUSI")).scrollToElement; });
$parcel$export(module.exports, "getThemeData", function () { return (parcelRequire("4XCT3")).getThemeData; });
$parcel$export(module.exports, "waitForElement", function () { return (parcelRequire("5BaYK")).waitForElement; });
parcelRequire("hDdJN");
parcelRequire("fnNvV");
parcelRequire("7YAJ4");
parcelRequire("2pyvk");
parcelRequire("9uiPq");
parcelRequire("cPDzI");
parcelRequire("9vUSI");
parcelRequire("4XCT3");
parcelRequire("5BaYK");

});
parcelRegister("hDdJN", function(module, exports) {

$parcel$export(module.exports, "b64_decode", function () { return $cd60bc3867d72b58$export$bf9d481ba07b53f9; });
var $cd60bc3867d72b58$export$3c2a198a9c1ae5f3 = function(string) {
    return window.btoa(unescape(encodeURIComponent(string)));
};
var $cd60bc3867d72b58$export$bf9d481ba07b53f9 = function(string) {
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("fnNvV", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", function () { return $b32f6972fc6e67b5$export$1191989ae3ee4c15; });
var $b32f6972fc6e67b5$export$1191989ae3ee4c15 = function() {
    var cookies = document.cookie.split('; ');
    var allCookies = [];
    cookies.forEach(function(cookie) {
        var cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("7YAJ4", function(module, exports) {

$parcel$export(module.exports, "elementReady", function () { return $5cea9fff8806cfad$export$5a68694636710d38; });
var $5cea9fff8806cfad$export$5a68694636710d38 = function(selector) {
    return new Promise(function(resolve) {
        var el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(function() {
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach(function(element) {
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });
};

});

parcelRegister("2pyvk", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", function () { return $1c18ae62fb4dbf93$export$5f2cd73bfe4df536; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return $1c18ae62fb4dbf93$export$b502183889628ce0; });
var $1c18ae62fb4dbf93$export$5f2cd73bfe4df536 = function(callback) {
    var timeout;
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
var $1c18ae62fb4dbf93$export$b502183889628ce0 = function(callback) {
    var timeout;
    window.addEventListener('scroll', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("9uiPq", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return $6e85854efd3089cd$export$26ae508a4c7ca84d; });

var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");

var $4XCT3 = parcelRequire("4XCT3");
var $6e85854efd3089cd$export$26ae508a4c7ca84d = function(action) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _themeData_ajax_actions, themeData, e;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $4XCT3.getThemeData)()
                    ];
                case 1:
                    themeData = _state.sent();
                    if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
                    if (!((_themeData_ajax_actions = themeData.ajax_actions) === null || _themeData_ajax_actions === void 0 ? void 0 : _themeData_ajax_actions.recaptcha_verify)) throw new Error('Missing AJAX route to verify reCAPTCHA token');
                    if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            if (window.grecaptcha === undefined) {
                                console.warn('Google reCAPTCHA is not loaded');
                                resolve({
                                    success: true,
                                    score: 1
                                });
                            } else window.grecaptcha.ready(function() {
                                window.grecaptcha.execute(themeData.recaptcha_site_key, {
                                    action: action
                                }).then(function(token) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                        var formData, testParam, url, response, json, errorMessages, e;
                                        return (0, $gh3Df._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    formData = new FormData();
                                                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                                                    // Determine if request is just a test
                                                    testParam = 'e2e-test';
                                                    url = new URL(window.location);
                                                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                                                    // Set reCAPTCHA token
                                                    formData.append('recaptcha_token', token);
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        fetch(themeData.ajax_route, {
                                                            method: 'POST',
                                                            body: formData
                                                        })
                                                    ];
                                                case 2:
                                                    response = _state.sent();
                                                    return [
                                                        4,
                                                        response.json()
                                                    ];
                                                case 3:
                                                    json = _state.sent();
                                                    if (json.success) resolve(json);
                                                    else if (json['error-codes']) {
                                                        /**
								 * reCAPTCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ errorMessages = [];
                                                        json['error-codes'].forEach(function(errorCode) {
                                                            switch(errorCode){
                                                                case 'missing-input-secret':
                                                                    errorMessages.push('The secret parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-secret':
                                                                    errorMessages.push('The secret parameter is invalid or malformed.');
                                                                    break;
                                                                case 'missing-input-response':
                                                                    errorMessages.push('The response parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-response':
                                                                    errorMessages.push('The response parameter is invalid or malformed.');
                                                                    break;
                                                                case 'bad-request':
                                                                    errorMessages.push('The request is invalid or malformed.');
                                                                    break;
                                                                case 'timeout-or-duplicate':
                                                                    errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                                                    break;
                                                                default:
                                                                    errorMessages.push('Unknown reCAPTCHA error code');
                                                            }
                                                        });
                                                        throw new Error("There was an error when trying to verify the user's response by reCAPTCHA:\n".concat(errorMessages.join('\n')));
                                                    } else if (json.data) throw new Error("The request to verify the reCAPTCHA user token failed: ".concat(response.data));
                                                    else throw new Error('Unknown error occurred when trying to verify the reCAPTCHA user token');
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 4:
                                                    e = _state.sent();
                                                    reject(e);
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                            });
                        })
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};

});
parcelRegister("4XCT3", function(module, exports) {

$parcel$export(module.exports, "getThemeData", function () { return $39cad640efa60b84$export$3c72f11fd9e5031f; });
var $39cad640efa60b84$export$3c72f11fd9e5031f = function() {
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        var sessionStorageKey = 'themeData';
        return new Promise(function(resolve, reject) {
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then(function(res) {
                return res.json();
            }).then(function(data) {
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch(function(e) {
                return reject(e);
            });
        });
    }
};

});


parcelRegister("cPDzI", function(module, exports) {

$parcel$export(module.exports, "slideUp", function () { return $9578f243206a91ae$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $9578f243206a91ae$export$abdd11a06a163232; });
var $9578f243206a91ae$export$deed561b1a0ff1ea = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        window.setTimeout(function() {
            if (!isSearchable) target.style.display = 'none';
            [
                'height',
                'padding-top',
                'padding-bottom',
                'margin-top',
                'margin-bottom',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$abdd11a06a163232 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        if (!isSearchable) {
            target.style.removeProperty('display');
            var display = window.getComputedStyle(target).display;
            if (display === 'none') display = 'block';
            target.style.display = display;
        }
        var height = target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        [
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom'
        ].forEach(function(prop) {
            return target.style.removeProperty(prop);
        });
        window.setTimeout(function() {
            [
                'height',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$715de50cedc228a8 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    return window.getComputedStyle(target).display === 'none' ? $9578f243206a91ae$export$abdd11a06a163232(target, duration) : $9578f243206a91ae$export$deed561b1a0ff1ea(target, duration);
};

});

parcelRegister("9vUSI", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", function () { return $6ed321ce261ae421$export$2353115f31f4d15; });
var $6ed321ce261ae421$export$2353115f31f4d15 = function(selector) {
    var targetEl = document.querySelector(selector);
    if (!targetEl) return;
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top);
};

});

parcelRegister("5BaYK", function(module, exports) {

$parcel$export(module.exports, "waitForElement", function () { return $4138ec9fb36217c9$export$1a1c301579a08d1e; });
var $4138ec9fb36217c9$export$1a1c301579a08d1e = function(selector) {
    return new Promise(function(resolve) {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        var observer = new MutationObserver(function() {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});



var $dxEC4 = parcelRequire("dxEC4");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $gh3Df = parcelRequire("gh3Df");
parcelRequire("6VBea");
var $cPDzI = parcelRequire("cPDzI");
var $50c3e6b85960a334$var$SELECTORS = {
    accordion: '.accordion',
    tab: '.tab',
    tabMeta: '.tab__meta',
    tabContent: '.tab__content'
};
var $50c3e6b85960a334$var$CSS_CLASSES = {
    open: 'open',
    allowMultiple: 'accordion--allow-multiple'
};
var $50c3e6b85960a334$var$SLIDE_DURATION = 500;
var $50c3e6b85960a334$var$AccordionTab = /*#__PURE__*/ function() {
    "use strict";
    function AccordionTab(tabElement) {
        (0, $4QweW._)(this, AccordionTab);
        var content = tabElement.querySelector($50c3e6b85960a334$var$SELECTORS.tabContent);
        var header = tabElement.querySelector($50c3e6b85960a334$var$SELECTORS.tabMeta);
        if (!content || !header) throw new Error('Accordion tab is missing its header or content element.');
        this.element = tabElement;
        this.content = content;
        this.header = header;
    }
    (0, $6hK4i._)(AccordionTab, [
        {
            key: "isOpen",
            get: function get() {
                return this.element.classList.contains($50c3e6b85960a334$var$CSS_CLASSES.open);
            }
        },
        {
            key: "open",
            value: function open() {
                if (this.isOpen) return;
                this.element.classList.add($50c3e6b85960a334$var$CSS_CLASSES.open);
                this.content.removeAttribute('hidden');
                (0, $cPDzI.slideDown)(this.content, $50c3e6b85960a334$var$SLIDE_DURATION, true);
            }
        },
        {
            key: "close",
            value: function close() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOpen) return [
                                    2
                                ];
                                return [
                                    4,
                                    (0, $cPDzI.slideUp)(this.content, $50c3e6b85960a334$var$SLIDE_DURATION, true)
                                ];
                            case 1:
                                _state.sent();
                                this.element.classList.remove($50c3e6b85960a334$var$CSS_CLASSES.open);
                                this.content.setAttribute('hidden', 'until-found');
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return AccordionTab;
}();
var $50c3e6b85960a334$var$Accordion = /*#__PURE__*/ function() {
    "use strict";
    function Accordion(element) {
        (0, $4QweW._)(this, Accordion);
        this.element = element;
        this.allowMultiple = element.classList.contains($50c3e6b85960a334$var$CSS_CLASSES.allowMultiple);
        this.tabs = this.createTabs();
        this.init();
    }
    (0, $6hK4i._)(Accordion, [
        {
            key: "createTabs",
            value: function createTabs() {
                return Array.from(this.element.querySelectorAll($50c3e6b85960a334$var$SELECTORS.tab)).map(function(tabElement) {
                    return new $50c3e6b85960a334$var$AccordionTab(tabElement);
                });
            }
        },
        {
            key: "init",
            value: function init() {
                this.openDefaultTab();
                this.bindEvents();
            }
        },
        {
            key: "openDefaultTab",
            value: function openDefaultTab() {
                var _this_element_getAttribute;
                var defaultIndex = parseInt((_this_element_getAttribute = this.element.getAttribute('data-start-index')) !== null && _this_element_getAttribute !== void 0 ? _this_element_getAttribute : '', 10);
                if (defaultIndex && this.tabs[defaultIndex - 1]) this.tabs[defaultIndex - 1].open();
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                var _this = this;
                this.tabs.forEach(function(tab) {
                    // Handle browser's find-in-page functionality
                    tab.element.addEventListener('beforematch', function() {
                        if (!tab.isOpen) tab.open();
                    });
                    // Handle click events
                    tab.header.addEventListener('click', function() {
                        _this.handleTabClick(tab);
                    });
                });
            }
        },
        {
            key: "handleTabClick",
            value: function handleTabClick(clickedTab) {
                if (clickedTab.isOpen) clickedTab.close();
                else {
                    if (!this.allowMultiple) this.closeAllTabs();
                    clickedTab.open();
                }
            }
        },
        {
            key: "closeAllTabs",
            value: function closeAllTabs() {
                this.tabs.filter(function(tab) {
                    return tab.isOpen;
                }).forEach(function(tab) {
                    return tab.close();
                });
            }
        }
    ]);
    return Accordion;
}();
// Initialize all accordions
document.querySelectorAll($50c3e6b85960a334$var$SELECTORS.accordion).forEach(function(element) {
    return new $50c3e6b85960a334$var$Accordion(element);
});

})();
//# sourceMappingURL=accordion.min.js.map
